<template>
  <el-card>
    <h4 class="card-title">{{ $t('hotSearch') }}</h4>
    <div class="card-content" v-if="data && data.length">
      <ul class="data-list">
        <li class="hot-search-item pointer" v-for="(item, index) in data" :key="item" @click="handleSearchItem(item)">{{index + 1}}. {{ item }}</li>
      </ul>
    </div>
    <bsp-empty small-empty v-else></bsp-empty>
  </el-card>
</template>

<script>
  export default {
    name: "HotSearch",
    props: {
      data: {
        type: Array,
        default() {
          return []
        }
      }
    },
    data() {
      return {
      }
    },
    methods: {
      // 热门搜索点击，代入搜索框
      handleSearchItem(val) {
        this.$emit('search', val);
      }
    }
  }
</script>

<style scoped>

</style>
